import DbUserTitle from "app/pages/db/user/DbUserTitle";
import EnergySplyStatus from "app/pages/db/modules/EnergySplyStatus";
import ElecUsageFee from "app/pages/db/modules/ElecUsageFee";
import DbUserRealTimePowerGen from "app/pages/db/client/DbUserRealTimePowerGen";
import DbUserDayPowerGen from "app/pages/db/client/DbUserDayPowerGen";
import PchsDesc from "app/pages/db/modules/PchsDesc";
import NoticeNews from "app/pages/db/modules/NoticeNews";
import DbUserDayCarbonEmission from "../client/DbUserDayCarbonEmission";
import DbUserDayCarbonReduction from "../client/DbUserDayCarbonReduction";
import React from "react";

export default function DbR005Base() {

  return (
    <div className="container">
      <div className="dashboard-wrap">
        <DbUserTitle title="나의 대시보드" configButtonVisible={false} />
        <div className="dashboard-wrap">
          <div className="col-wrap">
            <EnergySplyStatus />
            <ElecUsageFee />
          </div>
          <div className="col-wrap">
            <DbUserRealTimePowerGen />
            <DbUserDayPowerGen />
          </div>
          <div className="col-wrap">
            <DbUserDayCarbonEmission/>
            <DbUserDayCarbonReduction/>
          </div>
          <div className="col-wrap">
            <PchsDesc />
            <NoticeNews />
          </div>
        </div>
      </div>
    </div>
  );
}